import { Injector, assertInInjectionContext, inject, runInInjectionContext, signal } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { NgrxSelect, fastPropGetter } from './select';

function assertInjector(fn: Function, injector?: Injector): Injector {
    // we only call assertInInjectionContext if there is no custom injector
    !injector && assertInInjectionContext(fn);
    // we return the custom injector OR try get the default Injector
    return injector ?? inject(Injector);
}

export function useState<T = any>(
    path: string,
    { injector }: { injector?: Injector } = {},
) {
    assertInInjectionContext(useState);
    injector = assertInjector(useState, injector);

    return runInInjectionContext(injector, () => {
        const store = NgrxSelect.store;

        if (!store) {
            const empty = signal(null);
            return empty.asReadonly();
        }

        const propsArray = path.split('.');
        const fn = fastPropGetter(propsArray);
        const state$ = store.select(fn);

        return toSignal<T>(state$, { injector });
    })
}